/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespShopByModuleItem_item = {
    readonly title: string | null;
    readonly description: string | null;
    readonly cta: string | null;
    readonly imageUrl: string | null;
    readonly imageHeight: string | null;
    readonly imageWidth: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"HpRespModuleItemTile_linkData">;
    };
    readonly " $refType": "HpRespShopByModuleItem_item";
};
export type HpRespShopByModuleItem_item$data = HpRespShopByModuleItem_item;
export type HpRespShopByModuleItem_item$key = {
    readonly " $data"?: HpRespShopByModuleItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespShopByModuleItem_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespShopByModuleItem_item",
  "type": "Product",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageHeight",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageWidth",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "HpRespModuleItemTile_linkData",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '6d5281e425e2cb0d040dc5b1dc3b9528';
export default node;
